export default require('./messages_ja.json');
